import React from 'react';
import PropTypes from 'prop-types';
import { ControlLabel } from 'react-bootstrap';


const FieldLabel = ({ label }) => (
  <ControlLabel>
    {label}
  </ControlLabel>
);

FieldLabel.propTypes = {
  /** Input label */
  label: PropTypes.string,
};

FieldLabel.defaultProps = {
  label: '',
};

export default FieldLabel;
